import {CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule, DatePipe} from "@angular/common";
import {TabsModule} from "ngx-bootstrap";
import {MatSelectModule} from "@angular/material/select";
import {MatDialogModule} from "@angular/material/dialog";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {AutocompleteModule, ButtonsModule, PaginationMapsModule} from "maps-angular-components";
import {AutocompleteLibModule} from "angular-ng-autocomplete";
import {MatStepperModule} from "@angular/material/stepper";
import {MatTabsModule} from "@angular/material/tabs";
import {SharedModule} from "../shared/shared.module";
import {GrupoCarteiraComponent} from "./grupo-carteira/grupo-carteira.component";
import {CadastroGrupoCarteiraComponent} from "./cadastro-grupo-carteira/cadastro-grupo-carteira.component";
import {GerenciadorRegistrosComponent} from "./gerenciar-registro/gerenciador-registros.component";
import {MatButtonModule} from "@angular/material/button";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatInputModule} from "@angular/material/input";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatMenuModule} from "@angular/material/menu";
import {
  ModalEditarGrupoCarteiraComponent
} from './gerenciar-registro/modal-editar-grupo-carteira/modal-editar-grupo-carteira.component';
import {
  ModalDeletarGrupoCarteiraComponent
} from './gerenciar-registro/modal-deletar-grupo-carteira/modal-deletar-grupo-carteira.component';

@NgModule({
  declarations: [
    GrupoCarteiraComponent,
    CadastroGrupoCarteiraComponent,
    GerenciadorRegistrosComponent,
    ModalEditarGrupoCarteiraComponent,
    ModalDeletarGrupoCarteiraComponent
  ],
  imports: [
    CommonModule,
    TabsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatDialogModule,
    MatCheckboxModule,
    ButtonsModule,
    AutocompleteModule,
    AutocompleteLibModule,
    FormsModule,
    SharedModule,
    MatStepperModule,
    MatTabsModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatInputModule,
    MatFormFieldModule,
    MatMenuModule,
    PaginationMapsModule
  ],
  exports: [
    GrupoCarteiraComponent,
  ],
  providers: [DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class GrupoCarteiraModule {
}
